import './Pricing.scss'
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Alert, Button, Col, Container, Row} from "react-bootstrap";
import {useContext, useEffect, useState} from "react";
import AppContext from "../AppContext";
import {FaCheck} from "react-icons/fa6";
import {useParams, Navigate, Link} from "react-router-dom";
import API, {HandleError} from "../API";
import {useSnackbar} from "notistack";
import {renderToStaticMarkup} from "react-dom/server";
import {Plan} from "../models/Plan";
import {useTranslation} from "react-i18next";

export default function Pricing() {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(true)
    const [plans, setPlans] = useState([])
    var badCourse = false

    const { course_id } = useParams();
    if([1,2,3].indexOf(parseInt(course_id)) === -1) {
        badCourse = true
    }

    useEffect(() => {
        getPlans()
    }, [])

    if(badCourse)
        return <Navigate to="/" />

    const getPlans = async () => {
        try {
            const res = await API({
                method: 'GET',
                url: `/plans/${course_id}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            let plans = res.data.items.map((jsonData, idx) => {
                return new Plan(jsonData)
            })
            setPlans(plans)
            setLoading(false)
        }
        catch(e) {
            setLoading(false)
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div id="page-pricing" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container>
                <h1 className="text-center title">{t('pricing.title')}</h1>
                <h3 className="text-center text-muted">
                    {t('pricing.subtitle')}
                </h3>
                {plans.length > 0 ?
                <div className="pricing-section mt-5">
                    <Row className="card-deck mb-3 text-center">
                        {plans.map((plan, idx) => {
                            let details = plan.details.replaceAll('<li>', '<li>' + renderToStaticMarkup(<FaCheck />));
                            return <Col md={12} lg={4} key={'plan-' + plan.ID}>
                                <div className={"card mb-4 " + (idx === 1 ? 'best-deal' : '')}>
                                    <div className="card-header py-3">
                                        <h4 className="my-0">{plan.name}</h4>
                                    </div>
                                    <div className="card-body">
                                        <h1 className="card-title pricing-card-title mt-4">
                                            {plan.full_price > plan.price &&
                                            <div className="original-price">
                                                €{plan.full_price}
                                            </div>}
                                            €{plan.price}
                                        </h1>
                                        <div className="my-4" dangerouslySetInnerHTML={{__html: details}} />
                                        <Link to={`/checkout/${plan.ID}`} className="btn btn-primary btn-lg d-block w-100" role="button">{t('button.select')}</Link>
                                    </div>
                                </div>
                            </Col>
                        })}
                    </Row>
                </div> :
                    (loading ? <div className="mt-5 text-center">{t('loading')}</div> : <div className="mt-5">
                        <Alert variant="warning">
                            {t('pricing.noPlans')}
                        </Alert>
                        <Link to="/">{t('button.back')}</Link>
                    </div>)
                }
            </Container>
        </div>
    </div>
}